<template>
  <div class="privacy-policy">
    <h1>About Us</h1>
    <section>
      <p>
        BANFAAN is an innovative company dedicated to providing the ultimate gaming experience for players around the world. Our flagship product has more than 40 carefully designed game tracks, covering a wide range of themes from future cities to mysterious natural landscapes, to science fiction and historical scenes. Each track is carefully created by our talented design team to provide players with a unique racing experience.</p>
      <p>
At BANFAAN, we believe that games are not only a way of entertainment, but also a bridge to explore the world, challenge yourself and connect with others. Through continuous technological innovation and creative design, we strive to create a gaming environment that can inspire players' imagination and passion. Join us and start an unparalleled gaming journey together.
      </p>
   
    </section>

    <!-- 更多部分... -->
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>

<style scoped>
.privacy-policy {
  padding: 30px;
  font-family: Arial, sans-serif;
  max-width: 960px;
  margin: auto;
}

.privacy-policy h1,
.privacy-policy h2 {
  color: #333;
}

.privacy-policy p {
  line-height: 1.6;
  margin-bottom: 1em;
}

.privacy-policy ul {
  list-style-type: disc;
  margin-left: 20px;
}

.privacy-policy section {
  margin-bottom: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/views/pages/AboutUs.vue